module.exports = __webpack_public_path__ + "img/40.75cf3148.png";